import http from "../utils/http"

/**
 * 獲取網站信息
 */
export function websiteInfo(params) {
    return http({
        url: "/api/website/info",
        data: params
    })
}

/**
 * 獲取版權信息
 */
export function copyRight(params) {
    return http({
        url: "/api/config/copyright",
        data: params
    })
}

/**
 * 獲取wap端二維碼
 */
export function wapQrcode(params) {
    return http({
        url: "/api/website/wapqrcode",
        data: params
    })
}

export function siteDefaultFiles(params) {
    return http({
        url: "/api/config/defaultimg",
        data: params
    })
}

/**
 * 廣告圖
 * @param {Object} params 參數
 */
export function adList(params) {
    return http({
        url: "/api/adv/detail",
        data: params
    })
}

/**
 * 獲取商家服務
 */
export function shopServiceLists(params) {
    return http({
        url: "/api/shopservice/lists",
        data: params
    })
}

/**
 * 友情鏈接
 * @param {Object} params 參數
 */
export function friendlyLink(params) {
    return http({
        url: "/api/pc/friendlyLink",
        data: params
    })
}

/**
 * 導航
 * @param {Object} params 參數
 */
export function navList(params) {
    return http({
        url: "/api/pc/navList",
        data: params
    })
}

/**
 * 獲取驗證碼
 */
export function captcha(params) {
    return http({
        url: "/api/Captcha/captcha",
        data: params
    })
}